import { render, staticRenderFns } from "./online-platform.vue?vue&type=template&id=3227e12a"
import script from "./online-platform.vue?vue&type=script&lang=js"
export * from "./online-platform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports